import _ from 'lodash';
import { useRef } from 'react';
import { useStorage } from '../hooks/use-storage';
import { useNoPaymentModal } from '../screens/payment/no-payment-modal';
import { usePaymentSelectAmountModal } from '../screens/payment/payment-select-amount-modal';
import { filterByUser, isPayable } from '../utils/manager/order-manager';

function usePaymentSelectionWorkflow() {
  const { preparePaymentSelectAmmountModal, showPaymentSelectAmmountModal } =
    usePaymentSelectAmountModal();
  const { showNoPaymentModal } = useNoPaymentModal();
  const { user } = useStorage();

  const allOrdersRef = useRef();
  const selectOrdersRef = useRef();
  const userOrdersRef = useRef();

  async function prepare({ selectedOrders, updateOrders }) {
    allOrdersRef.current = await updateOrders();
    selectOrdersRef.current = selectedOrders;
    userOrdersRef.current = filterByUser(allOrdersRef.current, user);

    await preparePaymentSelectAmmountModal({
      allOrders: allOrdersRef.current,
      selectedOrders: selectOrdersRef.current,
      userOrders: userOrdersRef.current,
    });

    return null;
  }

  async function show({
    showBackButton,
    autoLoaded,
    prepareOnPreConfirm,
    prepareOnPreDeny,
    wasBackButtonClicked,
  } = {}) {
    if (_.isEmpty(allOrdersRef.current?.filter((o) => isPayable(o)))) {
      if (!autoLoaded) {
        await showNoPaymentModal();
      }

      return {
        isEmptyOrders: true,
      };
    }

    const result = await showPaymentSelectAmmountModal({
      showBackButton,
      prepareOnPreConfirm,
      prepareOnPreDeny,
      wasBackButtonClicked,
    });

    return result;
  }

  return {
    preparePaymentSelectionWorkflow: prepare,
    showPaymentSelectionWorkflow: show,
  };
}

export { usePaymentSelectionWorkflow };
